import { Link, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { DevToolbar } from '../harness/DevToolbar';
import { PreviewShell } from '../harness/PreviewShell';
import { getModule, listModules } from '../harness/ModuleRegistry';
import { Showcase } from './Showcase';

function PreviewRoute() {
  const { moduleId } = useParams<{ moduleId: string }>();
  if (!moduleId) {
    return <Navigate to="/preview" replace />;
  }
  const m = getModule(moduleId);
  if (!m) {
    return (
      <PreviewShell>
        <div className="flex h-full items-center justify-center px-sp-5 text-center text-text-muted">
          module «{moduleId}» not registered
        </div>
      </PreviewShell>
    );
  }
  const Component = m.Component;
  return (
    <PreviewShell moduleId={m.id} status={m.status}>
      <Component />
    </PreviewShell>
  );
}

function PreviewIndex() {
  const list = listModules();
  return (
    <main className="min-h-dvh bg-surface-main p-sp-7 text-text-primary">
      <span className="font-ui text-caption uppercase tracking-[0.2em] text-text-muted">
        preview index
      </span>
      <h1 className="mt-sp-3 font-display text-display leading-[1.1]">Модули</h1>
      <ul className="mt-sp-6 space-y-sp-3">
        {list.length === 0 && (
          <li className="text-text-muted">пока ни одного зарегистрированного модуля</li>
        )}
        {list.map((m) => (
          <li key={m.id}>
            <Link
              to={`/preview/${m.id}`}
              className="inline-flex items-baseline gap-sp-3 text-text-primary hover:text-accent-cyan"
            >
              <span className="font-ui">{m.id}</span>
              <span className="text-text-muted">— {m.title}</span>
              <span className="text-caption uppercase tracking-[0.15em] text-text-muted">
                [{m.status}]
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to="/"
        className="mt-sp-7 inline-block text-caption text-text-muted hover:text-text-primary"
      >
        ← на главный flow
      </Link>
    </main>
  );
}

export function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Showcase />} />
        <Route path="/preview" element={<PreviewIndex />} />
        <Route path="/preview/:moduleId" element={<PreviewRoute />} />
      </Routes>
      {import.meta.env.DEV && <DevToolbar />}
    </>
  );
}
